import React from 'react';
import { string, shape, arrayOf, bool } from 'prop-types';
import classnames from 'classnames';
import './tooltip-content.scss';

export const TooltipContent = (props) => {
  const {
    hoveredCombinationDetails: {
      image,
      combinationDetails = [],
      pricing
    } = {}
  } = props;

  const {
    message,
    shouldHidePriceForMap,
    isSpecialPrice,
    strikeThroughPriceForMap,
    price
  } = pricing || {};

  const { formatted } = price || {};

  const priceWrapperClasses = classnames('u__bold', {
    'u--hide': shouldHidePriceForMap,
    'u__text--success': isSpecialPrice
  });
  const priceContainerClasses = classnames({
    'body__line-through': strikeThroughPriceForMap
  });

  return (
    <div className="super-sku__inline-tooltip u__text-align--center">
      <span>
        <img
          className="super-sku__inline-tooltip-image"
          src={image}
          alt="swatch"
        />
      </span>

      {(combinationDetails || []).map((attribute, attributeIndex) => {
        const attributeLabel = attribute.shouldDisplayAttributeLabel && `${attribute.attributeLabel}:`;
        return (
          <div
            key={`${attribute.attributeValue}-${attributeIndex}`}
            className="super-sku__inline-tooltip-attribute-info"
          >
            {attributeLabel} {attribute.attributeValue}
          </div>
        );
      })}
      {(formatted || message)
        && (
          <>
            {formatted && (
              <div className={priceWrapperClasses}>
                <div className={priceContainerClasses}>
                  {formatted}
                </div>
              </div>
            )}
            {message && (
              <div className="u__legal">
                {message}
              </div>
            )}
          </>
        )}
    </div>
  );
};

TooltipContent.displayName = 'TooltipContent';

TooltipContent.propTypes = {
  hoveredCombinationDetails: shape({
    image: string,
    combinationDetails: arrayOf(shape({
      attributeLabel: string,
      attributeValue: string,
      shouldDisplayAttributeLabel: bool
    })),
    pricing: shape({
      message: string,
      price: shape({
        formatted: string,
      })
    })
  }).isRequired
};
